// Methods not using "this" are implementing the interface and cannot be static
/* eslint-disable class-methods-use-this */

import { AxiosResponse } from 'axios';
import VersionedResource from '../VersionedResource';
import { MaturedSettings } from './loanaccounts/MaturedSettings';
import { StatusSettingsResource } from '../accountstatussettings/StatusSettingsResource';
import { StatusSettings } from '../accountstatussettings/StatusSettings';
import { MaturedStatusIndicator } from './statusindicators/MaturedStatusIndicator';

export class MaturedSettingsResource extends VersionedResource implements StatusSettingsResource {
  public async save(fiId: string, settings: MaturedSettings): Promise<MaturedSettings> {
    const url = `/api/rcx/config/${fiId}/loan-account-settings/matured`;

    const response: AxiosResponse = await this.apiClient.put(url, settings);
    return response.data.data;
  }

  createEmptySettings(): MaturedSettings {
    return {
      statusIndicator: MaturedStatusIndicator.UNSET,
      statusCodes: [],
    };
  }

  setIndicatorsOnSettings(settings: StatusSettings, values: string[], conditionalOr: boolean | null) {
    const maturedSettings = settings as MaturedSettings;
    if (values.length === 2) {
      if (conditionalOr) {
        maturedSettings.statusIndicator = MaturedStatusIndicator.STATUS_CODE_OR_MATURED_DATE;
      } else {
        maturedSettings.statusIndicator = MaturedStatusIndicator.STATUS_CODE_AND_MATURED_DATE;
      }
    } else if (values.length === 0) {
      maturedSettings.statusIndicator = MaturedStatusIndicator.UNSET;
    } else if (values[0] === 'MATURED_DATE') {
      maturedSettings.statusIndicator = MaturedStatusIndicator.MATURED_DATE;
    } else if (values[0] === 'STATUS_CODE') {
      maturedSettings.statusIndicator = MaturedStatusIndicator.STATUS_CODE;
    }
  }

  getIndicatorsFromSettings(settings: StatusSettings): string[] | null {
    const delinquentSettings = settings as MaturedSettings;
    let indicators: string[] = [];
    switch (delinquentSettings.statusIndicator) {
      case MaturedStatusIndicator.MATURED_DATE:
        indicators = [MaturedStatusIndicator.MATURED_DATE];
        break;


      case MaturedStatusIndicator.STATUS_CODE:
        indicators = [MaturedStatusIndicator.STATUS_CODE];
        break;

      case MaturedStatusIndicator.STATUS_CODE_OR_MATURED_DATE:
      case MaturedStatusIndicator.STATUS_CODE_AND_MATURED_DATE:
        indicators = [MaturedStatusIndicator.STATUS_CODE, MaturedStatusIndicator.MATURED_DATE];
        break;

      default:
        break;
    }

    return indicators;
  }

  getConditionalFromSettings(settings: StatusSettings): string | null {
    const delinquentSettings = settings as MaturedSettings;

    let conditional: string | null = null;
    switch (delinquentSettings.statusIndicator) {
      case MaturedStatusIndicator.STATUS_CODE_OR_MATURED_DATE:
        conditional = 'OR';
        break;

      case MaturedStatusIndicator.STATUS_CODE_AND_MATURED_DATE:
        conditional = 'AND';
        break;

      default:
        break;
    }

    return conditional;
  }
}

export default MaturedSettingsResource;
